import React from 'react'
import { createRoot } from 'react-dom/client'
import {createTheme} from '@mui/material/styles';
import {connect} from 'react-redux';
import storage from 'next-authentication-server/authentication/application/NextAuthenticationServerStorage'

import {ThemeProvider} from '@mui/material/styles';

import { NextAuthenticationServer } from 'next-authentication-server/authentication/NextAuthenticationServer'

import { enUS } from '@mui/material/locale';

const theme = createTheme({
  drawerWidth: { width: 240 },
  palette: {
    mode: 'dark',
  }
}, enUS);

const store = storage()


createRoot(document.getElementById('root')).render(<ThemeProvider theme={theme}><NextAuthenticationServer store={store} theme={theme}/></ThemeProvider>)